import React, { useContext, useState } from "react";
import { Alert, Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { UserDetailsContext } from "../../Context/userDetailsContext";
import { useNotifications } from "../../Context/NotificationsContext";

const DISMISS_KEY = "emun-notify-banner-dismissed";

const readDismissed = () => {
  try {
    return localStorage.getItem(DISMISS_KEY) === "1";
  } catch {
    return false;
  }
};

const NotificationPermissionBanner = () => {
  const { t } = useTranslation();
  const { userDetails } = useContext(UserDetailsContext);
  const { permission, requestPermission } = useNotifications();
  const [dismissed, setDismissed] = useState(readDismissed);

  if (!userDetails?.isAuthenticated || permission !== "default" || dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch {
      // Private mode: the banner simply shows again next visit.
    }
  };

  return (
    <Alert
      severity="info"
      sx={{ m: { xs: 1, md: 2 }, alignItems: "center" }}
      action={
        <Stack direction="row" gap={1}>
          <Button variant="contained" size="small" onClick={requestPermission}>
            {t("notif_enableBrowser")}
          </Button>
          <Button size="small" onClick={dismiss}>
            {t("notif_later")}
          </Button>
        </Stack>
      }
    >
      {t("notif_enableBrowserText")}
    </Alert>
  );
};

export default NotificationPermissionBanner;
